<div class="dashboardHeader">
  <h4 class="dashboardHeading text-shadow">Dashboard</h4>
  <!-- <p class="m-0 text-shadow">Breadcrumb</p> -->
</div>
<div class="col-12 cardContainer">
  <div class="w-100">
    <div class="tile_count">
      <div class="tile_stats_count">
        <span class="count_top"><i class="fa fa-user"></i> Total Assessment</span>
        <div class="count">{{dashboardCounts?.totalAssessmentCounts}}</div>
        <span *ngIf="dashboardCounts?.weeklyIncrement >= 0" class="count_bottom"><i class="green"><i class="fa fa-sort-asc"></i>{{dashboardCounts?.weeklyIncrement}}% </i> From last Week</span>
        <span *ngIf="dashboardCounts?.weeklyIncrement < 0" class="count_bottom"><i class="red"><i class="fa fa-sort-desc"></i>{{-dashboardCounts?.weeklyIncrement}}% </i> From last Week</span>
      </div>
      <div class="tile_stats_count">
        <span class="count_top"><i class="fa fa-user"></i> Student Assessments</span>
        <div class="count">{{dashboardCounts?.studentAssessmentCounts}}</div>
        <span class="count_bottom">Out of {{dashboardCounts?.totalStudents}} Students</span>
      </div>
      <!-- <div class="tile_stats_count">
        <span class="count_top"><i class="fa fa-user"></i> Faculty Assessments</span>
        <div class="count green">{{dashboardCounts?.facultyAssessmentCounts}}</div>
        <span class="count_bottom">Out of {{dashboardCounts?.totalFaculties}} Faculties</span>
      </div> -->
      <div class="tile_stats_count">
        <span class="count_top"><i class="fa fa-user"></i> Avg. Score Student</span>
        <div class="count" *ngIf="dashboardCounts?.studentAverageScore; else noAvgScore">{{dashboardCounts?.studentAverageScore | number : '1.2-2'}}</div>
        <ng-template #noAvgScore>N/A</ng-template>
        <span *ngIf="dashboardCounts?.studentAvgIncrement >= 0" class="count_bottom"><i class="green"><i class="fa fa-sort-asc"></i>{{dashboardCounts?.studentAvgIncrement}}% </i> From last Week</span>
        <span *ngIf="dashboardCounts?.studentAvgIncrement < 0" class="count_bottom"><i class="red"><i class="fa fa-sort-desc"></i>{{-dashboardCounts?.studentAvgIncrement}}% </i> From last Week</span>
      </div>
      <!-- <div class="tile_stats_count">
        <span class="count_top"><i class="fa fa-user"></i> Avg. Score Faculty</span>
        <div class="count">{{dashboardCounts?.facultyAverageScore}}</div>
        <span *ngIf="dashboardCounts?.facultyAvgIncrement < 0" class="count_bottom" ><i class="red"><i class="fa fa-sort-desc"></i>{{-dashboardCounts?.facultyAvgIncrement}}% </i> From last Week</span>
        <span *ngIf="dashboardCounts?.facultyAvgIncrement >= 0" class="count_bottom" ><i class="green"><i class="fa fa-sort-asc"></i>{{dashboardCounts?.facultyAvgIncrement}}% </i> From last Week</span>
      </div> -->
      <div class="tile_stats_count">
        <span class="count_top"><i class="fa fa-user"></i> Rank</span>
        <div class="count">{{dashboardCounts?.rank}}</div>
        <span class="count_bottom">Out of {{dashboardCounts?.totalInstitutes}} Institutions</span>
      </div>
    </div>
    <div class="clearfix"></div>

    <div class="card CardItem">
      <div class="col-12 p-0 row" style="margin-left: 3px;" >
        <div class="col-8 " style="height: 67px; margin-top: 5px;">
          <h4 class="graphHeading m-0">
            Dashboard of {{instituteName}}
          </h4>
        </div>
        <div class="col-4" style="height: 67px; margin-top: 5px;">
          <mat-form-field appearance="outline" class="w-100 p-0">
              <mat-label>Department</mat-label>
              <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">account_circle
              </mat-icon>
              <mat-select [(ngModel)]="totalParticipationDept" (selectionChange)="onDeptChangeforAll($event)">
                  <!-- <mat-option *ngFor="let batch of batches" [value]="batch">{{batch}}</mat-option> -->
                  <mat-option value=0>All</mat-option>
                  <mat-option *ngFor="let dept of departments" [value]="dept?.id">{{dept?.department}}</mat-option>
              </mat-select>
          </mat-form-field>
        </div>
        <!-- <div class="col-6"></div> -->
      </div>
      <div class="col-12 p-0" style="display: flex; flex-direction: row">
        <div class="col-8 floatLeft p-0">
          <div class="card CardItem">
            <h6 class="graphInnerHeading">Student Assessment Count - Monthwise</h6>
            <apx-chart
              [series]="StudentFacultyAssessment.series"
              [chart]="StudentFacultyAssessment.chart"
              [dataLabels]="StudentFacultyAssessment.dataLabels"
              [plotOptions]="StudentFacultyAssessment.plotOptions"
              [yaxis]="StudentFacultyAssessment.yaxis"
              [legend]="StudentFacultyAssessment.legend"
              [fill]="StudentFacultyAssessment.fill"
              [stroke]="StudentFacultyAssessment.stroke"
              [tooltip]="StudentFacultyAssessment.tooltip"
              [xaxis]="StudentFacultyAssessment.xaxis"
              style="flex-grow: 1"
            ></apx-chart>
          </div>
        </div>
        <div class="col-4 floatLeft p-0">
          <div *ngIf="!departmentPerformance || departmentPerformance.length === 0" class="card CardItem">
            <h6 class="graphInnerHeading">Top Disciplines</h6>
            <h5 style="text-align: center; color: #73879C; padding-top: 35px;">No Data</h5>
            <div class="col-12" fxFlex="100" style="margin-bottom: 15px;" *ngIf="deptPerLoader">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
          <div *ngIf="departmentPerformance.length != 0" class="card CardItem">
            <h6 class="graphInnerHeading">Top Disciplines</h6>
            <div *ngFor="let dept of departmentPerformance;let i=index" class="progressBarContainer">
              <p *ngIf="(i<=8) && (dept?.avg>=40)" class="progressBarHeading">{{dept?.department}}</p>
              <mat-progress-bar *ngIf="(i<=8) && (dept?.avg>=40)"
                class="example-margin"
                color="#26B99A"
                mode="determinate"
                value="{{dept?.avg}}"
              >
              </mat-progress-bar>
              <div *ngIf="(i<=8) && (dept?.avg>=40)" class="progressBarCount">{{dept?.avg}}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>

    <div class="col-12 p-0">
      <div class="col-12 p-0 d-flex">
        <div class="col-4 floatLeft p-0">
          <div class="CardItem h-100">
            <h6 class="graphInnerHeading">Students Performance</h6>
            <div class="col-12 mt-2">
              <select class="form-control chartDropdown" [(ngModel)]="studentPerformanceDept" (change)="onDeptChange($event)">
                <option value=0>All</option>
                <option *ngFor="let dept of departments" [value]="dept?.id">{{dept?.department}}</option>
              </select>
            </div>
            <div *ngIf="!ratings">
              <h4 style="text-align: center; color: #73879C; padding-top: 25px;">No performance data</h4>
            </div>
            <div *ngIf="ratings">
              <p class="ratingHeading">Rating</p>
              <div class="ratingProgressBarContainer">
                <p class="ratingProgressBarHeading">3 Star</p>
                <mat-progress-bar
                  class="example-margin"
                  mode="determinate"
                  value="{{ratings?.perc3}}"
                >
                </mat-progress-bar>
                <div class="ratingProgressBarCount">{{ratings?.rating3}}</div>
              </div>
              <div class="ratingProgressBarContainer">
                <p class="ratingProgressBarHeading">4 Star</p>
                <mat-progress-bar
                  class="example-margin"
                  mode="determinate"
                  value="{{ratings?.perc4}}"
                >
                </mat-progress-bar>
                <div class="ratingProgressBarCount">{{ratings?.rating4}}</div>
              </div>
              <div class="ratingProgressBarContainer">
                <p class="ratingProgressBarHeading">5 Star</p>
                <mat-progress-bar
                  class="example-margin"
                  mode="determinate"
                  value="{{ratings?.perc5}}"
                >
                </mat-progress-bar>
                <div class="ratingProgressBarCount">{{ratings?.rating5}}</div>
              </div>
              <div class="ratingProgressBarContainer">
                <p class="ratingProgressBarHeading">Others</p>
                <mat-progress-bar
                  class="example-margin"
                  mode="determinate"
                  value="{{ratings?.perc2}}"
                >
                </mat-progress-bar>
                <div class="ratingProgressBarCount">{{ratings?.rating2}}</div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="col-4 floatLeft p-0">
          <div class="CardItem h-100">
            <h6 class="graphInnerHeading">Top Specializations</h6>
            <div class="col-12 mt-2">
              <select class="form-control chartDropdown" [(ngModel)]="topSpecsDept" (change)="onDeptChangeTopic($event)">
                <option *ngFor="let dept of departments" [value]="dept?.id">{{dept?.department}}</option>
              </select>
            </div>
            <div *ngIf="Specializations['series'][0]">
              <apx-chart id="Specializations"
                [series]="Specializations.series"
                [chart]="Specializations.chart"
                [labels]="Specializations.labels"
                [fill]="Specializations.fill"
                [plotOptions]="Specializations.plotOptions"
                [colors]="Specializations.colors"
                [dataLabels]="Specializations.dataLabels"
                [responsive]="Specializations.responsive"
                style="top: 10px"
              ></apx-chart>
            </div>
            <div *ngIf="!Specializations['series'][0]">
              <h4 style="text-align: center; color: #73879C; padding-top: 25px;">No Specializations Data</h4>
              <div class="col-12" fxFlex="100" style="margin-bottom: 15px;">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="col-4 floatLeft p-0">
          <div class="CardItem h-100">
            <h6 class="graphInnerHeading">Total Participation</h6>
            <div class="col-12 mt-2">
              <select class="form-control chartDropdown" [(ngModel)]="totalParticipationDept" (change)="onDeptChangeParticipants($event)">
                <option value=0>All</option>
                <option *ngFor="let dept of departments" [value]="dept?.id">{{dept?.department}}</option>
              </select>
            </div>
            <div class="ParticipationChartContainer">
              <apx-chart
                [series]="TotalParticipation.series"
                [chart]="TotalParticipation.chart"
                [plotOptions]="TotalParticipation.plotOptions"
                [labels]="TotalParticipation.labels"
                [colors]="TotalParticipation.colors"
              >
              </apx-chart>
              <div class="ParticipationChartValBox">
                <p>{{totalParticipation?.totalAssessmentCount}}</p>
                <p>{{totalParticipation?.totalStudentsAdded}}</p>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>

    <div class="col-12 d-flex p-0 mt-4">
      <div class="col-4 w-100 p-0 floatLeft">
        <div class="card CardItem">
          <div class="col-12 p-0 h-100">
            <h6 class="graphInnerHeading m-0">
              Recent Activities
            </h6>
            <div *ngIf="!lastAssessments[0]">
              <h3 style="text-align: center; color: #73879C; padding-top: 25px;">
                <a>No Recent Activities</a>
              </h3>
            </div>
            <div *ngIf="lastAssessments[0]" style="min-height: 525px" class="pl-2">
              <ul class="recentActivityList">
                <li *ngFor='let activity of lastAssessments; index as i' class="recentActivityListItem">
                  <div class="recentActivityItemBox">
                    <div class="recentActivityItemBoxcontent">
                      <h2 class="recentActivitytitle">
                        <a>{{activity?.course}}</a>
                      </h2>
                      <div class="recentActivityDateBy">
                        <span>{{activityTiming[i]}} ago</span> by <a>{{activity?.name}}</a>
                      </div>
                        <p class="recentActivityDescription row">
                          <span *ngIf='activity?.current_year==1' class="EventbodyText col-4">Year : {{activity?.current_year}}st</span>
                          <span *ngIf='activity?.current_year==2' class="EventbodyText col-4">Year : {{activity?.current_year}}nd</span>
                          <span *ngIf='activity?.current_year==3' class="EventbodyText col-4">Year : {{activity?.current_year}}rd</span>
                          <span *ngIf='activity?.current_year==4 || activity?.current_year==5' class="EventbodyText col-4">Year : {{activity?.current_year}}th</span>
                          <span class="col-2"></span>
                          <span class="col-6">
                            <div class="half-stars-example" *ngIf="activity?.assessmentRating==1">
                                <div *ngFor="let rate of rating1">
                                    <svg class="review__star {{rate}}" width="20" height="20" viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="half-stars-example" *ngIf="activity?.assessmentRating==2">
                                <div *ngFor="let rate of rating2">
                                    <svg class="review__star {{rate}}" width="20" height="20" viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="half-stars-example" *ngIf="activity?.assessmentRating==3">
                                <div *ngFor="let rate of rating3">
                                    <svg class="review__star {{rate}}" width="20" height="20" viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="half-stars-example" *ngIf="activity?.assessmentRating==4">
                                <div *ngFor="let rate of rating4">
                                    <svg class="review__star {{rate}}" width="20" height="20" viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="half-stars-example" *ngIf="activity?.assessmentRating==5">
                                <div *ngFor="let rate of rating5">
                                    <svg class="review__star {{rate}}" width="20" height="20" viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                    </svg>
                                </div>
                            </div>
                          </span>
                        </p>
                        
                      <p style="font-size: 14px;">   
                        <!-- {{activity?.topics}} <a>Read&nbsp;More</a> -->
                        {{(activity?.readMore) ? (activity?.topics) : (activity?.topics) | slice:0:100}} <span *ngIf="!activity['readMore']">...</span>
                        <a href="javascript:;" *ngIf="activity['readMore']==false" (click)="activity['readMore']=true">[Read More]</a>
                        <a href="javascript:;" *ngIf="activity['readMore']==true" (click)="activity['readMore']=false">[Read Less]</a>
                      </p> 
                    </div>
                  </div>
                </li>
                <!--- <li class="recentActivityListItem" *ngIf="isShowing">
                  <div class="recentActivityItemBox">
                    <div class="recentActivityItemBoxcontent">
                      <h2 class="recentActivitytitle">
                        <a
                          >Who Needs Sundance When You’ve
                          Got&nbsp;Crowdfunding?</a
                        >
                      </h2>
                      <div class="recentActivityDateBy">
                        <span>13 hours ago</span> by <a>Jane Smith</a>
                      </div>
                      <p class="recentActivityDescription">
                        Film festivals used to be do-or-die moments for movie
                        makers. They were where you met the producers that could
                        fund your project, and if the buyers liked your flick,
                        they’d pay to Fast-forward and… <a>Read&nbsp;More</a>
                      </p>
                    </div>
                  </div>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8 w-100 h-100 p-0 floatLeft">
        <div class="col-12 p-0 mb-4">
          <div class="card CardItem">
            <h6 class="graphInnerHeading m-0">
              Overall Performance <small>at Country Level</small>
            </h6>
            <div class="col-12 p-0 d-flex">
              <div class="col-8 p-0 floatLeft">
                <div class="col-12 p-0">
                  <apx-chart
                    [series]="AverageScore.series"
                    [chart]="AverageScore.chart"
                    [plotOptions]="AverageScore.plotOptions"
                    [labels]="AverageScore.labels"
                    [fill]="AverageScore.fill"
                    [stroke]="AverageScore.stroke"
                  ></apx-chart>
                </div>
              </div>
              <div class="col-4 p-0 floatLeft">
                <div class="col-12 h-100 w-100">
                  <h6 class="graphInnerHeading m-0 pl-0">
                    Institute Score : <span>{{globalScores?.averageScore}}</span>
                  </h6>
                  <div class="col-12 p-0">
                    <ul class="instituteScoreList">
                      <li>Country <span>{{globalScores?.averageScoreCountry}}</span></li>
                      <li>State <span>{{globalScores?.averageScoreState}}</span></li>
                      <li>District <span>{{globalScores?.averageScoreDistrict}}</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="card CardItem">
            <h6 class="graphInnerHeading m-0">Student Performance in last 365 days</h6>
            <apx-chart
              [series]="PerformanceScore.series"
              [chart]="PerformanceScore.chart"
              [xaxis]="PerformanceScore.xaxis"
              [yaxis]="PerformanceScore.yaxis"
              [dataLabels]="PerformanceScore.dataLabels"
              [legend]="PerformanceScore.legend"
              [colors]="PerformanceScore.colors"
              [grid]="PerformanceScore.grid"
              [markers]="PerformanceScore.markers"
            ></apx-chart>
            <div *ngIf="counts" class="miniCard">
              <div class="card col-6" style="margin-right: 5px;">
                <h6 class="miniCardInnerHeading m-0 text-center">Assessments by Institute</h6>
                <span class="row text-center"><p class="miniCardText col-4 p-0 m-0">Max : {{counts?.studentAssessmentMax}}</p><p class="miniCardText col-4 p-0 m-0">Min : {{counts?.studentAssessmentMin}}</p><p class="miniCardText col-4 p-0 m-0">Avg : {{counts?.studentAssessmentAvg}}</p></span>
              </div>
              <div class="card col-6">
                <h6 class="miniCardInnerHeading m-0 text-center">Self-Assessments</h6>
                <span class="row text-center"><p class="miniCardText col-4 p-0 m-0">Max : {{counts?.selfAssessmentMax}}</p><p class="miniCardText col-4 p-0 m-0">Min : {{counts?.selfAssessmentMin}}</p><p class="miniCardText col-4 p-0 m-0">Avg : {{counts?.selfAssessmentAvg}}</p></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>

    <div #graphArea class="col-12 d-flex p-0 mt-0">
      <div class="col-12 p-0">
        <div class="card CardItem">
          <h6 class="graphInnerHeading m-0">
            Monthly Performance <small>(Batchwise)</small>
          </h6>
          <apx-chart
            [series]="GraphArea.series"
            [chart]="GraphArea.chart"
            [xaxis]="GraphArea.xaxis"
            [yaxis]="GraphArea.yaxis"
            [stroke]="GraphArea.stroke"
            [tooltip]="GraphArea.tooltip"
            [dataLabels]="GraphArea.dataLabels"
            [colors]="GraphArea.colors"
            [markers]="GraphArea.markers"
            [legend]="GraphArea.legend"
          ></apx-chart>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</div>